export default {
  '/case/civilCase': 'case:manage:my:manage-',
  '/case/administrativeCase': 'case:manage:my:manage-',
  '/case/criminalCase': 'case:manage:my:manage-',
  '/case/allCases': 'case:manage:all:manage-',
  '/case/obtainEvidenceCase': 'case:manage:my:manage-',
  '/case/seriousCase': 'case:manage:my:serious:manage:-',
  '/case/allSerious': 'case:manage:serious:manage:-',
  '/case/mySerious': 'case:manage:serious:manage:-',

  '/case/pendingMyCase': 'case:manage:my:manage-',
  '/case/ongoingMyCase': 'case:manage:my:manage-',
  '/case/allMyCase': 'case:manage:my:manage-',

  '/case/pendingSeriousCase': 'case:manage:my:serious:manage:-',
  '/case/ongoingSeriousCase': 'case:manage:my:serious:manage:-',
  '/case/allSeriousCase': 'case:manage:my:serious:manage:-',

  '/project/myManage': 'project:manage:manage-',
  '/project/collaborate': 'project:manage:my:helper:manage-',
  '/project/allProjects': 'project:manage:all:manage-',

  '/relationship/myClient': 'market-center:customer:my:manage-',
  '/relationship/collaborativeCustomers': 'market-center:customer:cooperation:manage-',
  '/relationship/allCustomers': 'market-center:customer:all:manage-',

  '/relationship/myChannel': 'market-center:channel:my:manage-',
  '/relationship/cooperativeChannels': 'market-center:channel:cooperation:manage-',
  '/relationship/allChannels': 'market-center:channel:all:manage-',

  '/settlementCenter/lawyerSettlement': 'case:manage:my:manage-',
  '/settlementCenter/mediationSettlement': 'case:manage:my:manage-'
}



// WEBPACK FOOTER //
// ./src/libs/permission.js